// import { AxiosInstance } from "axios";
import { BaseService } from "./baseService";
import { SnaptixHidden } from "./snaptix";
import { AbstractDBContent, Content, ContentKey, ContentService, DBContentMode } from "./content";
// import { PageService } from "./page";

export const enum ProductSlug
{
    Alpha = "active-alpha",
    Axil = "active-axil",
    AxilCurve = "active-axil-curve",
    AxilEdge = "active-axil-edge",
    AxilMiniAir = "active-axil-mini-air",
    AxilMiniPro = "active-axil-mini-pro",
    Ceramic = "active-ceramic",
    Clone = "active-clone",
    Glass = "active-glass",
    EzClickCeramicPro = "ezclick-ceramic-pro",
    EzClickGlass = "ezclick-glass",
    EzClickGlassPlus = "active-ezclick-glass-plus",
    EzClickPoly = "ezclick-poly",
    EzClickPolyPlus = "active-ezclick-poly-plus",
    EzClickXLPoly = "ezclick-xl-poly",
    EzClickXLGlassPlus = "active-ezclick-xl-glass-plus",
    EzClickXLCeramicPro = "ezclick-xl-ceramic-pro",
    Leaf = "active-leaf",
    Node = "active-node",
    Root = "active-root",
    RootXL = "active-root-xl",
    Seed = "active-seed",
    Stem = "active-stem",
    Stik = "active-stik",
    // StikButton = "active-stik-button",
    ActiveSeedling = "active-seedling",
    ActiveSprout = "active-sprout",
    ActiveMedley = "active-medley",
    ActiveSnaptix = "active-snaptix-mouthpiece",

    AxilS1Battery = "axil-s1-battery",
    OffsetS1Battery = "offset-s1-battery",
    AirPodPostless = "air-pod-postless",
    ProPodCeramic = "pro-pod-ceramic",
    ClassicPodStainless = "classic-pod-stainless",
    Singular510Adapter = "singular-510-adapter",
}

export const enum ProductCategorySlug
{
    AllInOnes = "all-in-ones",
    Batteries = "batteries",
    Cartridges = "cartridges",
    XLSeries = "xl-series",
    SingularProducts = "singular-products",
}

export const enum ProductType
{
    AllInOne,
    Battery,
    Cartridge,
    SingularProducts,
}

export const enum ProductSeries
{
    XL
}

interface ProductDescriptor
{
    enabled: boolean;
    isNew?: boolean;
    title: string;
    type: ProductType;
    series?: ProductSeries;
}

interface ProductCategoryDescriptor
{
    order: number;
}

export const allowFutureProducts = false;

export const ProductDescriptors: Record<ProductSlug, ProductDescriptor> = {
    [ProductSlug.Alpha]: { enabled: true, title: "Alpha Battery", type: ProductType.Battery, },
    [ProductSlug.Axil]: { enabled: true, title: "Axil All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.AxilCurve]: { enabled: true, title: "Axil Curve All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.AxilEdge]: { enabled: true, title: "Axil All-In-One Edge", type: ProductType.AllInOne, },
    [ProductSlug.AxilMiniAir]: { enabled: true, title: "Axil Mini Air All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.AxilMiniPro]: { enabled: true, title: "Axil Mini Pro All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.Ceramic]: { enabled: true, title: "Ceramic All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.Clone]: { enabled: true, title: "Clone Battery", type: ProductType.Battery, },
    [ProductSlug.Glass]: { enabled: true, title: "Glass All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.EzClickCeramicPro]: { enabled: true, title: "EZ Click Ceramic Pro", type: ProductType.Cartridge, },
    [ProductSlug.EzClickGlass]: { enabled: true, title: "EZ Click Glass", type: ProductType.Cartridge, },
    [ProductSlug.EzClickGlassPlus]: { enabled: true, title: "EZ Click Glass Plus", type: ProductType.Cartridge, },
    [ProductSlug.EzClickPoly]: { enabled: true, title: "EZ Click Poly", type: ProductType.Cartridge, },
    [ProductSlug.EzClickPolyPlus]: { enabled: true, title: "EZ Click Poly Plus", type: ProductType.Cartridge, },
    [ProductSlug.EzClickXLPoly]: { enabled: true, title: "EZ Click XL Poly", series: ProductSeries.XL, isNew: true, type: ProductType.Cartridge, },
    [ProductSlug.EzClickXLGlassPlus]: { enabled: true, title: "EZ Click XL Glass Plus", series: ProductSeries.XL, isNew: true, type: ProductType.Cartridge, },
    [ProductSlug.EzClickXLCeramicPro]: { enabled: true, title: "EZ Click XL Ceramic Pro", series: ProductSeries.XL, isNew: true, type: ProductType.Cartridge, },
    [ProductSlug.Leaf]: { enabled: true, title: "Leaf All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.Node]: { enabled: true, title: "Node All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.Root]: { enabled: true, title: "Root Battery", type: ProductType.Battery, },
    [ProductSlug.RootXL]: { enabled: true, title: "Root XL Battery", series: ProductSeries.XL, isNew: true, type: ProductType.Battery, },
    [ProductSlug.Seed]: { enabled: true, title: "Seed Battery", type: ProductType.Battery, },
    [ProductSlug.Stem]: { enabled: true, title: "Stem All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.Stik]: { enabled: true, title: "Stik Battery", type: ProductType.Battery, },
    // [ProductSlug.StikButton]: { enabled: true, title: "Stik Button Battery", type: ProductType.Battery, },
    [ProductSlug.ActiveSeedling]: { enabled: true, title: "Seedling Battery", type: ProductType.Battery, },
    [ProductSlug.ActiveSprout]: { enabled: true, title: "Sprout Battery", type: ProductType.Battery, },
    [ProductSlug.ActiveMedley]: { enabled: true, title: "Medley All-In-One", type: ProductType.AllInOne, },
    [ProductSlug.ActiveSnaptix]: { enabled: !SnaptixHidden, title: "Snaptix Mouthpiece", type: ProductType.Cartridge, },

    [ProductSlug.AxilS1Battery]: { enabled: true, title: "Axil S1 Battery", type: ProductType.SingularProducts },
    [ProductSlug.OffsetS1Battery]: { enabled: true, title: "Offset S1 Battery", type: ProductType.SingularProducts },
    [ProductSlug.AirPodPostless]: { enabled: true, title: "Air Pod: Postless", type: ProductType.SingularProducts },
    [ProductSlug.ProPodCeramic]: { enabled: true, title: "Pro Pod: Ceramic", type: ProductType.SingularProducts },
    [ProductSlug.ClassicPodStainless]: { enabled: true, title: "Classic Pod: Stainless", type: ProductType.SingularProducts },
    [ProductSlug.Singular510Adapter]: { enabled: true, title: "510 Adapter", type: ProductType.SingularProducts },
};

export const ProductCategoryDescriptors: Record<ProductCategorySlug, ProductCategoryDescriptor | undefined> = {
    [ProductCategorySlug.AllInOnes]: { order: 2 },
    [ProductCategorySlug.Batteries]: { order: 5 },
    [ProductCategorySlug.Cartridges]: { order: 3 },
    [ProductCategorySlug.XLSeries]: { order: 4 },
    [ProductCategorySlug.SingularProducts]: { order: 1 },
};

export interface ProductCategoryRaw<DateType = string>
{
    createdAt: DateType;
    id: string;
    label: string;
    slug: string;
    updatedAt: DateType;
    description: string | null;
}

export interface ProductRaw<DateType = string>
{
    createdAt: DateType;
    homePageOrder: number | null;
    id: string;
    order: number | null;
    productCategory: Pick<ProductCategoryRaw<DateType>, "id"> | null;
    shortDescription: string | null;
    slug: string;
    subTitle: string | null;
    thumbPath: string | null;
    title: string | null;
    updatedAt: DateType;
    seoTitle: string | null;
    seoDescription: string | null;
    seoSchema: string | null;
    permalink: string | null;
}

export interface Product<DateType = string> extends ProductRaw<DateType>
{
    descriptor: ProductDescriptor;
}

export type ProductContentMode = DBContentMode.Html | DBContentMode.Text;

export interface ProductContent<DateType = string> extends AbstractDBContent<ProductContentMode, DateType>
{
    product: Pick<Product<DateType>, "id">;
}

export type ProductContentCreate = Omit<ProductContent, "id" | "createdAt" | "product" | "updatedAt"> & Required<Pick<ProductContent, "product">>;

export interface ProductTag<DateType = string>
{
    color: string | null;
    createdAt: DateType;
    id: string;
    product: Pick<Product<DateType>, "id"> | null;
    slug: string;
    textColor: string | null;
    title: string;
    updatedAt: DateType;
}

export interface ProductCategory<DateType = string> extends ProductCategoryRaw<DateType>
{
    descriptor: ProductCategoryDescriptor;
}

export interface ProductFull<DateType = string> extends Omit<Product<DateType>, "productCategory">
{
    category?: ProductCategory<DateType>;
    tags: ProductTag<DateType>[];
}

export class ProductService extends BaseService
{

    public static async getAll(): Promise<Product[]>
    {
        return this.getByParams({
            orderBy: {
                homePageOrder: "asc"
            }
        });
    }

    public static async getBareContent<Keys extends readonly ContentKey[]>(productOrSlug: Product | string, keys: Keys): Promise<Content<Keys[number]>>
    {
        return ContentService.get(
            await this.getContent(productOrSlug),
            keys,
            message => console.warn(`[ProductService.getBareContent][product = ${typeof productOrSlug === "string" ? productOrSlug : productOrSlug.slug}]: ${message}`)
        );
    }

    public static async getBareContentJS<Keys extends readonly ContentKey[]>(productOrSlug: Product | string, keys: Keys): Promise<string>
    {
        return ContentService.getJS(await this.getContent(productOrSlug), keys);
    }

    public static async getBySlug(slug: string): Promise<Product | undefined>
    {
        const products = await this.getByParams({
            where: {
                slug: {
                    equals: slug
                }
            }
        });
        return products.pop();
    }

    public static async getCategories(): Promise<ProductCategory[]>
    {
        const response = await this.getData<ProductCategoryRaw[]>("/productCategories");

        return response
            .map(category =>
            {
                const descriptor = ProductCategoryDescriptors[category.slug as ProductCategorySlug];
                return descriptor !== undefined ? { ...category, descriptor } : undefined;
            })
            .filter(category => category !== undefined) as ProductCategory[];
    }

    public static async getContent(productOrSlug: Product | string): Promise<ProductContent[]>
    {
        const product = typeof productOrSlug === "string" ? await this.getBySlug(productOrSlug) : productOrSlug;

        if (product === undefined)
        {
            return [];
        }

        const response = await this.getData<ProductContent[]>("/productContents", {

                where: {
                    product: {
                        id: product.id
                    }
                },
                orderBy: {
                    order: 'asc'
                }

        });
        return response;
    }

    public static async getFull(): Promise<{ categories: ProductCategory[]; products: ProductFull[] }>
    {
        const [allProducts, allCategories, allTags] = await Promise.all([
            this.getAll(),
            this.getCategories(),
            this.getTags()
        ]);

        const products = allProducts.map(product => this.toFull(product, allCategories, allTags));
        const categories = allCategories
            .filter(category => 
                products.some(product => product.category?.id === category.id) &&
                products.some(product => product.category?.slug !== ProductCategorySlug.XLSeries)
            );

        return {
            categories, products
        };
    }

    /**
     * Like getFull(), but strips fields that no menu/slider consumer renders (per-product SEO
     * blobs, timestamps, secondary order, tags). The Header (rendered in the root layout on
     * EVERY page) and the homepage ProductSlider only read
     * id/slug/title/subTitle/permalink/shortDescription/homePageOrder/descriptor and
     * category {id, slug, descriptor}. Serializing the full objects into the RSC flight stream
     * was dead weight (~28KB on the homepage, where products are serialized once for the Header
     * and again for the slider). The ProductFull shape is preserved (keys kept, values emptied)
     * so callers stay type-compatible. Keep in sync with MainMenu/ProductCard/ProductSlider if
     * their field usage changes.
     */
    public static async getFullSlim(): Promise<{ categories: ProductCategory[]; products: ProductFull[] }>
    {
        const { categories, products } = await this.getFull();

        const slimCategory = (c: ProductCategory): ProductCategory =>
            ({ ...c, createdAt: "", updatedAt: "", description: null });

        return {
            categories: categories.map(slimCategory),
            products: products.map(product => ({
                ...product,
                createdAt: "",
                updatedAt: "",
                order: null,
                seoTitle: null,
                seoDescription: null,
                seoSchema: null,
                thumbPath: null,
                tags: [],
                category: product.category ? slimCategory(product.category) : product.category,
            })),
        };
    }

    public static async getFullBySlag(slug: string): Promise<ProductFull | undefined>
    {
        const [product, categories, allTags] = await Promise.all([
            this.getBySlug(slug),
            this.getCategories(),
            this.getTags()
        ]);

        return product !== undefined ? this.toFull(product, categories, allTags) : undefined;
    }

    public static async getTags(): Promise<ProductTag[]>
    {
        return this.getTagsByParams();
    }

    private static async getByParams(params?: any): Promise<Product[]>
    {

        const response = await this.getData<ProductRaw[]>("/products", params );
        return response.map(this.fromRaw).filter(product => product !== undefined) as Product[];
    }

    private static async getTagsByParams(params?: any): Promise<ProductTag[]>
    {
        const response = await this.getData<ProductTag[]>("/tags", params );
        return response;
    }

    public static async getProduct(id: string): Promise<Product | undefined>
    {
        const response = await this.getData<ProductRaw>(`/products/${id}`);
        return this.fromRaw(response);
    }

    public static async getXLs(): Promise<ProductFull[]>
    {
        const xlSlugs = [
            ProductSlug.EzClickXLPoly,
            ProductSlug.EzClickXLGlassPlus,
            ProductSlug.EzClickXLCeramicPro,
            ProductSlug.RootXL,
        ] as const;

        const { products: allProducts } = await this.getFull();
        return xlSlugs.map(slug => allProducts.find(e => e.slug === slug)).filter(e => e !== undefined) as ProductFull[];
    }

    public static async getFullBySlugs(slugs: string[]): Promise<ProductFull[]> {
        const [allCategories, allTags] = await Promise.all([
            this.getCategories(),
            this.getTags()
        ]);

        const products = await Promise.all(slugs.map(slug => this.getBySlug(slug)));
        return products
            .filter(product => product !== undefined)
            .map(product => this.toFull(product!, allCategories, allTags));
    }

    public static async getSimilarContent(productOrSlug: Product | string) {
        const content = await this.getContent(productOrSlug);
        const similarProductsSlugs = content
            .filter(c => c.key?.startsWith('similar-product'))
            .map(item => item.data ?? '');

        return this.getFullBySlugs(similarProductsSlugs);
    }

    // public static async migrateContent<Keys extends readonly ContentKey[]>(oldPageSlug: string, newProductSlug: string, keys: Keys): Promise<void>
    // {
    //     const oldPageContent = await PageService.getContent(oldPageSlug);
    //
    //     ContentService.validate(oldPageContent, keys, { allowExceptions: true, slug: oldPageSlug });
    //
    //     this.synchronizeContent(newProductSlug, ContentService.get(oldPageContent, keys), keys);
    // }
    //
    // public static async synchronizeContent<Keys extends readonly ContentKey[]>(productOrSlug: Product | string, newContent: Content<Keys[number]>, keys: Keys, options?: ContentSynchronizeOptions): Promise<void>
    // {
    //     const product = typeof productOrSlug === "string" ? await this.getBySlug(productOrSlug) : productOrSlug;
    //
    //     if (product === undefined)
    //     {
    //         throw new Error(`Product with slug ${productOrSlug} not found`);
    //     }
    //
    //     let adminConnection: AxiosInstance | undefined;
    //
    //     ContentService.synchronize({
    //         keys,
    //         newContent,
    //         oldContent: await this.getContent(product),
    //         onCreate: async (key, item, order) =>
    //         {
    //             adminConnection = adminConnection ?? this.createAdminConnection();
    //             await adminConnection.post("/productContents", {
    //                 data: item.data,
    //                 key,
    //                 mode: ContentTypeMap[item.type] as ProductContentMode,
    //                 order,
    //                 product: {
    //                     id: product.id
    //                 }
    //             } satisfies ProductContentCreate);
    //         },
    //         onChange: async (id, item, order) =>
    //         {
    //             adminConnection = adminConnection ?? this.createAdminConnection();
    //             await adminConnection.put(`/productContents/${id}`, {
    //                 data: item.data,
    //                 mode: ContentTypeMap[item.type] as ProductContentMode,
    //                 order
    //             });
    //         },
    //         onDelete: async id =>
    //         {
    //             adminConnection = adminConnection ?? this.createAdminConnection();
    //             await adminConnection.delete(`/productContents/${id}`);
    //         },
    //         truncateFirst: options?.truncateFirst
    //     });
    // }

    private static fromRaw(raw: ProductRaw): Product | undefined
    {
        const descriptor = ProductDescriptors[raw.slug as ProductSlug] as (ProductDescriptor | undefined);
        return descriptor?.enabled ? { ...raw, descriptor } : undefined;
    }

    private static toFull(product: Product, categories: ProductCategory[], allTags: ProductTag[]): ProductFull
    {
        const categoryId = product.productCategory?.id;
        const category = categoryId !== undefined ? categories.find(category => category.id === categoryId) : undefined;

        const slug = product.slug;
        const tags: ProductTag[] = [];
        if (slug === "active-ezclick-poly-plus" || slug === "active-ezclick-glass-plus" || slug === "active-ezclick-xl-glass-plus")
        {
            const tag = allTags.find(tag => tag.slug === "plus");
            if (tag !== undefined)
            {
                tags.push(tag);
            }
        }
        else if (slug === "ezclick-ceramic-pro" || slug === "ezclick-xl-ceramic-pro")
        {
            const tag = allTags.find(tag => tag.slug === "pro");
            if (tag !== undefined)
            {
                tags.push(tag);
            }
        }
        else if (slug === "ezclick-poly" || slug === "ezclick-glass" || slug === "ezclick-xl-poly")
        {
            const tag = allTags.find(tag => tag.slug === "classic");
            if (tag !== undefined)
            {
                tags.push(tag);
            }
        }

        return { ...product, category, tags };
    }
}